// extracted by mini-css-extract-plugin
var _1 = "VerifyCertifyStyle-module__container___mFHLc";
var _2 = "VerifyCertifyStyle-module__header___zRj9H";
var _3 = "VerifyCertifyStyle-module__inner-wrapper___BN4xo";
var _4 = "VerifyCertifyStyle-module__inner-wrapper___BN4xo";
var _5 = "VerifyCertifyStyle-module__link-btn___au3Gy";
var _6 = "VerifyCertifyStyle-module__link-btn___au3Gy";
var _7 = "VerifyCertifyStyle-module__list___p4LHH";
var _8 = "VerifyCertifyStyle-module__list-element___P1Mj4";
var _9 = "VerifyCertifyStyle-module__list-element___P1Mj4";
var _a = "VerifyCertifyStyle-module__text-style___N5WcB";
var _b = "VerifyCertifyStyle-module__text-style___N5WcB";
export { _1 as "container", _2 as "header", _3 as "inner-wrapper", _4 as "innerWrapper", _5 as "link-btn", _6 as "linkBtn", _7 as "list", _8 as "list-element", _9 as "listElement", _a as "text-style", _b as "textStyle" }
